import React from 'react';
import {PropTypes} from 'prop-types';

import copy from "../copy";
import {Input} from "../../components/input";
import {validateCity} from "../../utils/validation";

/**
 * Reusable component for rendering city form field
 *
 * @param {string}                 value - input value
 * @param {boolean|string}         error - whether or not the input should show the error view. When string, contains the error message
 * @param {function}               onChange - onChange event handler
 * @param {string}                 controlId - input control id
 */
export function CityField({error, ...props}) {
    return (
        <Input
            {...copy.city}
            autoValidateAndFormat
            validator={validateCity}
            required
            error={error && copy.city.errorMessage}
            onBlur={props.onChange}
            {...props}
        />
    );
}

CityField.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string]),
    error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    onChange: PropTypes.func,
    controlId: PropTypes.string, 
};
